import React from 'react';
import my from "../assets/mine.jpg";
import { NavLink } from "react-router-dom";
import "./Workcardstyle.css";

const Workcard = (props) => {
    return (
        <div className="role-card">
            <img src={props.imgsrc} alt="image" />
            <h2 className="title text-center">{props.title}</h2>
            <div className="details">
                <h2 className="text-center">{props.text}</h2>

                <div className="p-btns">
                    <NavLink to={props.view} className="btn">view</NavLink>
                    <NavLink to={props.social} className="btn">Social</NavLink>
                </div>
            </div>
        </div>
    )
}

export default Workcard;
